import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Group } from '../models/group';
import { Plant } from '../models/plant';

@Injectable({
  providedIn: 'root'
})

export class CilConfigurationService {
  o3CoreApiUrl: string = Constants.CORE_API_BASE_URL;

  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    const token = localStorage.getItem('token');
    //const token = this.hardCodeToken ;//localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'Common/GetGroup', data, { headers: header });
  }

  GetPlantByEgDDL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get<any[]>(this.o3CoreApiUrl + 'DMS/GetPlantByEgDDL', { headers: header, params: { Id: data.Id } });
  }

  async GetCILData(data: any): Promise<any> {
    return await this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetCILData', data).toPromise();
  }
  GetCILDataForSFDC(data:any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization',  `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetCILData', data, {headers: header} );
  }
  GetTreeModal(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'Common/GetTreeModal', data, { headers: header });
  }

  GetCompModelTreeForCIL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetCompModelTreeForCIL', data, { headers: header });
  }

  GetMachineModelTreeForCIL(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetMachineModelTreeForCIL', data, { headers: header });
  }

  PerformCilTask(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/InsertCILTransaction', data, { headers: header });
  }

  performCilAction(data: any): any {
    const token = localStorage.getItem('token');
    const header = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/InsertCILTransactionMultiple', data, { headers: header });
  }
  getLineList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetLineList', data);
  }
  getUnitList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetUnitList', data);
  }
  getAssemblyList(data: any): Observable<any[]> {
    // return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetAssemblyList', data);
    return this.http.post<any[]>(this.o3CoreApiUrl + 'Dashboard/GetAssemblyList', data);
  }
  getComponentListByAssembly(data: any): Observable<any> {
    return this.http.post<any>(this.o3CoreApiUrl + 'CIL/GetComponentListByAssembly', data);
  }
 
  getTaskAssignedUsers(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CoreApiUrl + 'CIL/GetTaskAssignedUsers', data);
  }
}
